module.exports = __webpack_public_path__ + "static/media/icon-edit.54179a33.svg";